import React, {useRef} from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography, IconButton, Tooltip } from '@material-ui/core';
import { hasPermission, hasAtLeastOnePermission, formatDate } from '../../../sc-utilities';
import ErasureHistoryList from './ErasureHistoryList';
import { CloudDownload } from '@material-ui/icons';
import * as actions from '../store/historyActions';
import config from '../../../../config/config';
import {snackActions} from "../../../sc-utilities/SnackBar";
import {download} from "../../../sc-utilities/download.utils";

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        marginTop: '-20px',
        paddingTop: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    }
});

const ErasureHistory = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions, productID, activeCustomerID } = props;
    let visible = columns && columns['ErasureHistory'];

    const handleDownload = async sessionID => {
        const objectURL = `${config.backend_domain}:${config.backend_port}/sessions/get_log_data?SessionID=${sessionID}&ActiveCustomerID=${activeCustomerID}`;
        let exportDataSuccessful = await download(objectURL);
        tableRef.current && tableRef.current.onQueryChange();
        if (!exportDataSuccessful) {
            return snackActions.snackBarComponent(translations['download_error_msg'] || `Could not download file `, 'error');
        }
    };

    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                <Tooltip title={translations['download_log'] || "Download log(s)"} >
                    <IconButton disabled={download[rowData.SessionID] ? download[rowData.SessionID] : false} aria-label={translations['download_log'] || "Download log(s)"} onClick={() => { handleDownload(rowData.SessionID) }}>
                        <CloudDownload />
                    </IconButton>
                </Tooltip>
            </>
        },
        {
            title: translations["finished_with_status"] || 'Finished with status', field: 'FinishedWithStatus',
            hidden: visible ? visible['FinishedWithStatus'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.FinishedWithStatus ? rowData.FinishedWithStatus : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["erased_by"] || 'Erased by', field: 'CreatedBy',
            hidden: visible ? visible['CreatedBy'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData['Created.Username'] ? rowData['Created.Username'] : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["started"] || 'Started', field: 'Started',
            hidden: visible ? visible['Started'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Started ? formatDate(rowData.Started) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["changed"] || 'Changed', field: 'Changed',
            hidden: visible ? visible['Changed'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Changed ? formatDate(rowData.Changed) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["finished"] || 'Finished', field: 'Finished',
            hidden: visible ? visible['Finished'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Finished ? formatDate(rowData.Finished) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["erase_session_type"] || 'Erase session type', field: 'EraseOnly',
            hidden: visible ? visible['EraseOnly'] : false,
            filtering: true,
            lookup: { '1': translations['single_disk_devices_only'] || 'Single-disk devices only', '0': translations['standard'] || 'Standard' },
            defaultFilter: ['0', '1'],
            render: rowData => {
                return <Typography variant={'caption'}>{!!rowData.EraseOnly ? translations['single_disk_devices_only'] || 'Single-disk devices only' : translations['standard'] || 'Standard'}</Typography>;
            }
        },
        {
            title: translations["responsible_user"] || 'Responsible User', field: 'ResponsibleUser',
            hidden: visible ? visible['ResponsibleUser'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ResponsibleUser ? rowData.ResponsibleUser : (translations['short_not_assigned'] || 'n/a')}</Typography>;
            }
        },
    ];

    if (!hasAtLeastOnePermission(permissions, ["processing_session_log_download"])) {
        tableColumns.shift();
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'product_view_history') ?
                <ErasureHistoryList
                    productID={productID}
                    tableColumns={tableColumns}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        generateSessionReport: params => dispatch(actions.generateSessionReport(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ErasureHistory));